import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';
import { put } from '../Shared/ajax';
import { getErrorMessage } from '../Shared/errorHandling';

interface UpdatePageRequest {
  externalId: string;
  metadata: string;
}

interface UpdatePageResponse {
  externalId: string;
}

export default async (
  pageId: string,
  pageSchema: string,
  enqueueSnackbar: (
    message: SnackbarMessage,
    options?: OptionsObject
  ) => SnackbarKey
) => {
  try {
    await put<UpdatePageResponse, UpdatePageRequest>('DynamicWorkflowPage', {
      externalId: pageId,
      metadata: pageSchema
    });
  } catch (err) {
    enqueueSnackbar(getErrorMessage(err), { variant: 'error' });
  }
};
